import { type DocumentMeta } from "@prismicio/editor-fields"

import type { DocumentVersionStatus } from "../app/services/core"

export function findDocumentVersion(params: {
  meta: DocumentMeta
  documentId: string
  releaseId: string | undefined
  archivedVersionId: string | undefined
  status: DocumentVersionStatus | undefined
}) {
  const { meta, documentId, releaseId, status, archivedVersionId } = params

  const isReleaseVersion = releaseId && status === "release"
  const isArchivedVersion = archivedVersionId && status === "archived"

  const { versions } = meta
  const releaseVersion =
    isReleaseVersion &&
    versions.find(
      (version) =>
        version.status === "release" && version.release_id === releaseId,
    )
  if (releaseVersion) return releaseVersion

  const archivedVersion =
    isArchivedVersion &&
    versions.find(
      (version) =>
        version.status === "archived" &&
        version.version_id === archivedVersionId,
    )
  if (archivedVersion) return archivedVersion

  const version = versions.find((version) => version.status === status)
  if (version) return version

  for (const nextBestStatus of statusPreferenceOrder) {
    const version = versions.find(({ status }) => status === nextBestStatus)

    if (version) return version
  }

  // This shouldn't happen, it makes the return type non optional.
  throw new Error(`The document ${documentId} doesn't have any versions.`)
}

const statusPreferenceOrder = [
  "unclassified",
  "published",
  "release",
  "archived",
] as const
